import React from 'react';
import { motion, useAnimation } from "framer-motion";
import { forwardRef, useCallback, useImperativeHandle, useRef } from "react";
import { cn } from "../../lib/utils";
const HAND_TRANSITION = {
  duration: 0.6,
  ease: [0.4, 0, 0.2, 1]
};
const HAND_VARIANTS = {
  normal: {
    rotate: 0,
    originX: "0%",
    originY: "100%"
  },
  animate: {
    rotate: 360,
    originX: "0%",
    originY: "100%"
  }
};
const MINUTE_HAND_TRANSITION = {
  duration: 0.5,
  ease: "easeInOut"
};
const MINUTE_HAND_VARIANTS = {
  normal: {
    rotate: 0,
    originX: "0%",
    originY: "100%"
  },
  animate: {
    rotate: 45,
    originX: "0%",
    originY: "100%"
  }
};
const ClockIcon = forwardRef(({
  onMouseEnter,
  onMouseLeave,
  className,
  size = 28,
  ...props
}, ref) => {
  const controls = useAnimation();
  const isControlledRef = useRef(false);
  useImperativeHandle(ref, () => {
    isControlledRef.current = true;
    return {
      startAnimation: () => controls.start("animate"),
      stopAnimation: () => controls.start("normal")
    };
  });
  const handleMouseEnter = useCallback(e => {
    if (isControlledRef.current) {
      onMouseEnter?.(e);
    } else {
      controls.start("animate");
    }
  }, [controls, onMouseEnter]);
  const handleMouseLeave = useCallback(e => {
    if (isControlledRef.current) {
      onMouseLeave?.(e);
    } else {
      controls.start("normal");
    }
  }, [controls, onMouseLeave]);
  return <div className={cn(className)} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} {...props}>
        <svg fill="none" height={size} stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" width={size} xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="12" r="10" />
          <motion.line animate={controls} initial="normal" transition={HAND_TRANSITION} variants={HAND_VARIANTS} x1="12" x2="12" y1="12" y2="6" />
          <motion.line animate={controls} initial="normal" transition={MINUTE_HAND_TRANSITION} variants={MINUTE_HAND_VARIANTS} x1="12" x2="16" y1="12" y2="12" />
        </svg>
      </div>;
});
ClockIcon.displayName = "ClockIcon";
export { ClockIcon };